import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { RoundedButton, Typography } from "@packages/ui";
import { Warning } from "@material-ui/icons";

const WarningScreen = ({ onExit }) => {
  return (
    <>
      <Grid item container md={12}>
        <Grid item md={12}>
          <Typography variant="h2" paragraph>
            <Warning />
            Terms and Conditions
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography paragraph>
            You will need to allow us to access your camera and device location
            details.
          </Typography>
          <Typography paragraph>
            Please ensure the vehicle is parked in a safe and clear space before clicking on the below button to proceed.
          </Typography>
          <div style={{marginLeft:'15px'}}>
          <RoundedButton title="I accept the terms and conditions" onClick={onExit} />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

WarningScreen.propTypes = {
  onExit: PropTypes.func.isRequired,
};

export default WarningScreen;
